<div class="sms-create">
    <div class="alert sms-alert text-center" *ngIf="!borrower.canText && !borrower.smsUnsubscribed">
        <strong>Business has not agreed to receive texts. To enable texting, ask for borrower consent before updating contact information.</strong>
    </div>
    <div class="alert sms-alert text-center" *ngIf="!borrower.canText && borrower.smsUnsubscribed">
        <strong>Business has not agreed to receive texts. To enable texts ask the borrower to text "Start" to your Lendio phone number.</strong>
    </div>
    <ng-container>
        <div class="tw-my-3 tw-ml-3 tw-pl-4 tw-rounded sms-warning text-center tw-w-1/2" *ngIf="borrower.canText && (marketingSmsOptIn$ | async)?.value !== '1'">
                <strong>This business has {{ (marketingSmsOptIn$ | async)?.value == 0 ? 'opted out of all' : 'not specified a preference for' }} cross-selling opportunities.</strong>
                <button class="update-button" (click)="openOptInStatusModal()">UPDATE</button>
        </div>
    </ng-container>
    <div class="alert sms-alert text-center" *ngIf="borrower.canText && borrower.smsUnsubscribed">
        <strong>Business has not agreed to receive texts. To enable texts ask the borrower to text "Start" to your Lendio phone number.</strong>
    </div>
    <div class="alert sms-alert text-center" *ngIf="borrower.canText && !borrower.smsUnsubscribed && content.trim().length >= 1600">
        <strong>Whoops, this message is too long. Try breaking it up into messages that are 1600 characters or less.</strong>
    </div>
    <div class="alert sms-alert text-center" *ngIf="showMissingNumberAlert">
        <strong>Cannot find the mobile number for the primary contact ({{ borrower.primary_contact.first }} {{ borrower.primary_contact.last }}) on this account.</strong>
    </div>
    <quill-editor
      class="tw-w-full"
      *ngIf="!borrower.smsUnsubscribed && borrower.canText"
      [placeholder]="placeholder" format="text"
      [(ngModel)]="content"
      (onEditorCreated)="handleEditorCreated($event)"
      (onSelectionChanged)="handleSelectionChange($event.range)"
      (onContentChanged)="handleContentChange()">
        <div quill-editor-toolbar class="px-0 tw-grid tw-grid-cols-[1fr_auto_auto]">
            <div data-cy="sms-editor-to" class="borrower-name pull-left mt-2" *ngIf="borrower.primary_contact">
                To: {{ borrower.primary_contact.first }} {{ borrower.primary_contact.last }}
            </div>
            <div class="tw-grid tw-gap-2 tw-grid-flow-col">
              <app-template-picker *ngIf="(templates$ | async)"
                                   [templates]='templates$ | async'
                                   [selectedTemplate]='selectedTemplate'
                                   (chooseTemplate)="chooseTemplate($event)">
              </app-template-picker>
                <div>
                    <button mat-button
                            data-cy="sms-link-btn"
                            class="tw-whitespace-nowrap !tw-w-fit !tw-min-w-fit"
                            [matMenuTriggerFor]="linkHandler"
                            (click)="getLinks()">
                        <span class="sms-insert-link-text">Add Link</span>
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #linkHandler>
                        <button class="link-list" mat-menu-item *ngFor="let link of links">
                            <a class="link-list-items tw-text-black" (click)="handleInsertLink(link.handler)">{{ link.label }}</a>
                        </button>
                    </mat-menu>
                </div>
                <div>
                    <button data-cy="sms-emoji-btn" id="add-emoji" class="mat-menu-sms" mat-button [matMenuTriggerFor]="emojiMart">
                        <i class="fa fa-lg fa-smile-o emoji-icon tw-text-gray-500"></i>
                    </button>
                    <mat-menu class="emoji-mart-mat-menu" #emojiMart>
                        <emoji-mart emoji="point_up" title="Pick your emoji..." (click)="$event.stopPropagation()" (emojiClick)="handleEmoji($event)"></emoji-mart>
                    </mat-menu>
                </div>
            </div>
        </div>
    </quill-editor>
    <div *ngIf="!borrower.smsUnsubscribed && borrower.canText">
        <div class="pull-right mt-2">
            <button
                class="send-sms"
                [ngClass]="{'send-sms-truthy': content.trim().length}"
                [disabled]="!content.trim().length || showMissingNumberAlert || content.trim().length >= 1600"
                (click)="handleSubmitSms()"
                mat-raised-button
                data-cy="sms-send-btn"
            >Send</button>
        </div>
        <div class="character-length pull-left mt-2">
            Length: <span *ngIf="content">{{ content.trim().length }}</span>
        </div>
    </div>
</div>
